import { createFeature, createReducer, on } from '@ngrx/store';

import * as actions from './shared-auth-state.actions';

export interface State {
  username: string;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  username: null,
  loaded: false,
  loading: false,
};

export default createFeature({
  name: 'sharedAuthState',
  reducer: createReducer(
  initialState,
  on(actions.reset, (state: State): State => ({
      ...state,
      loaded: false,
      loading: false
    })),
  on(actions.signingIn, (state: State, { }): State => ({
      ...state,
      loaded: false,
      loading: true
    })),
  on(actions.signedIn, (state: State, { username }): State => ({
      ...state,
      username,
      loaded: true,
      loading: false,
    })),
  on(actions.signOut, (state: State, { }): State => ({
      ...state,
      username: null,
      loaded: false,
      loading: false,
    })),
  )}
);